// Customers Locations Management routes
export default [
  {
    path: 'customers-locations-management',
    name: 'customers-locations-management',
    redirect: 'customers-locations-management/index',
    component: () =>
      import(
        /* webpackChunkName: "customersLocationsManagement" */ '../views/customersLocationsManagement/CustomersLocationsManagement.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'customersLocationsManagement',
        meta: {
          tabbable: true,
          tableKeys: ['customersLocations'],
          filterKeys: [],
          formKeys: ['customersLocations'],
          routePermissions: ['locationCustomerDepartmentView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "customersLocationsManagementIndex" */ '../views/customersLocationsManagement/CustomersLocationsManagementIndex.vue'
          ),
      },
    ],
  },
];
